import React from 'react';

const NewMeetingModal = ({
  isOpen,
  onClose,
  meetingConversation,
  newMeetingTitle,
  setNewMeetingTitle,
  newMeetingDate,
  setNewMeetingDate,
  newMeetingNotes,
  setNewMeetingNotes,
  onCreateMeeting
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-gray-900 border border-gray-400/20 rounded-2xl w-[500px] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 border-b border-gray-400/20">
          <h2 className="text-xl font-bold text-white">Create New Meeting</h2>
          <p className="text-gray-400 text-sm mt-1">Add {meetingConversation?.name} to a new meeting card</p>
        </div>
        
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Meeting Title</label>
            <input
              type="text"
              value={newMeetingTitle}
              onChange={(e) => setNewMeetingTitle(e.target.value)}
              placeholder="e.g., Property Viewing with John"
              className="w-full px-4 py-2 bg-gray-800 border border-gray-400/20 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Date</label>
            <input
              type="date"
              value={newMeetingDate}
              onChange={(e) => setNewMeetingDate(e.target.value)}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-400/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">Notes</label>
            <textarea
              value={newMeetingNotes}
              onChange={(e) => setNewMeetingNotes(e.target.value)}
              placeholder="Add meeting notes..."
              rows={4}
              className="w-full px-4 py-2 bg-gray-800 border border-gray-400/20 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
            />
          </div>
        </div>
        
        <div className="p-6 border-t border-gray-400/20 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onCreateMeeting}
            disabled={!newMeetingTitle}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
          >
            Create Meeting
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewMeetingModal;
